import moment from 'moment';

const shortDateFormat = 'MM/DD/YYYY';
const longDateTimeFormat = 'MMM D YYYY h:mm a ([GMT]Z)';

const dateFormat = (date, format = shortDateFormat) => {
  return (moment.isMoment(date))
    ? date.format(format)
    : moment(date).format(format);
};

export const formatUnixDate = (date, format = shortDateFormat) => {
  date = parseInt(date, 10);

  return dateFormat(date * 1000, format);
};

export const formatUnixDateTime = date => formatUnixDate(date, longDateTimeFormat);

export const getUnixDate = (unixDate) => {
  const date = parseInt(unixDate * 1000, 10) || unixDate;
  return moment(date);
};

export const getPeriodFromNow = date => getUnixDate(date).fromNow();

export default dateFormat;




// WEBPACK FOOTER //
// ./src/utils/dateFormat.js